"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyListWorkouts = void 0;
exports.listWorkoutsSetMock = listWorkoutsSetMock;
exports.listWorkouts = listWorkouts;
exports.useQueryListWorkouts = useQueryListWorkouts;
exports.useInfiniteQueryListWorkouts = useInfiniteQueryListWorkouts;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function listWorkoutsSetMock(mock) {
    setMock = mock;
}
async function listWorkouts(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/workout-store/${params.version}/workouts`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.exists = params.exists;
    queryParams.accountingProjectNumber = params.accountingProjectNumber;
    queryParams.allowRestricted = params.allowRestricted;
    queryParams.brightcoveVideoId = params.brightcoveVideoId;
    queryParams.categories = Array.isArray(params.categories) ? params.categories.join(',') : params.categories;
    queryParams.city = params.city;
    queryParams.continent = params.continent;
    queryParams.country = params.country;
    queryParams.createdByUser = params.createdByUser;
    queryParams.dashboardLabel = params.dashboardLabel;
    queryParams.difficulty = params.difficulty;
    queryParams.equipmentType = params.equipmentType;
    queryParams.hasBrightcoveVideoId = params.hasBrightcoveVideoId;
    queryParams.hasGeospatial = params.hasGeospatial;
    queryParams.hasVideo = params.hasVideo;
    queryParams.ids = Array.isArray(params.ids) ? params.ids.join(',') : params.ids;
    queryParams.isCrossTraining = params.isCrossTraining;
    queryParams.isDiscoverable = params.isDiscoverable;
    queryParams.isLiveWorkout = params.isLiveWorkout;
    queryParams.isPulseOptimized = params.isPulseOptimized;
    queryParams.labels = params.labels;
    queryParams.locationTypes = params.locationTypes;
    queryParams.ownerId = params.ownerId;
    queryParams.primaryLabel = params.primaryLabel;
    queryParams.publishStage = params.publishStage;
    queryParams.requiredEquipment = params.requiredEquipment;
    queryParams.returnFields = Array.isArray(params.returnFields) ? params.returnFields.join(',') : params.returnFields;
    queryParams.requestUnpublished = params.requestUnpublished;
    queryParams.state = params.state;
    queryParams.subcategories = params.subcategories;
    queryParams.subscriptionTypes = params.subscriptionTypes;
    queryParams.targetAreas = params.targetAreas;
    queryParams.targetType = params.targetType;
    queryParams.targetValue = params.targetValue;
    queryParams.terrainTypes = params.terrainTypes;
    queryParams.title = params.title;
    queryParams.trainer = params.trainer;
    queryParams.trim = Array.isArray(params.trim) ? params.trim.join(',') : params.trim;
    queryParams.type = params.type;
    queryParams.workoutCategories = params.workoutCategories;
    queryParams.workoutFilters = params.workoutFilters;
    queryParams.workoutGroupId = params.workoutGroupId;
    queryParams.page = params.page;
    queryParams.pageSize = params.pageSize;
    queryParams.sortAsc = params.sortAsc;
    queryParams.sortField = params.sortField;
    if (params['X-Llama-Namespaces'] !== undefined) {
        headers['X-Llama-Namespaces'] = params['X-Llama-Namespaces'];
    }
    if (params['X-Llama-Log-Level'] !== undefined) {
        headers['X-Llama-Log-Level'] = params['X-Llama-Log-Level'];
    }
    if (params['Cache-Control'] !== undefined) {
        headers['Cache-Control'] = params['Cache-Control'];
    }
    if (params.Accept !== undefined) {
        headers.Accept = params.Accept;
    }
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.workoutStoreIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyListWorkouts = 'workout-store:listWorkouts:get';
function useQueryListWorkouts(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyListWorkouts, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryListWorkouts(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyListWorkouts, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = listWorkouts(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=list-workouts.js.map